export const LIVE_WINS = '/live-wins/viewLiveWins'
